import React from 'react';

const LOGOS = {
  horizontal: '/brand/logo-horizontal.png',
  primary: '/brand/logo-primary.png',
  mark: '/brand/logo-mark.png',
};

export default function BrandLogo({
  className = '',
  variant = 'horizontal',
  height = 44,
}) {
  const src = LOGOS[variant] || LOGOS.horizontal;

  return (
    <span className={`brand-logo ${className}`.trim()}>
      <img
        className={`brand-logo-image brand-logo-image-${variant}`}
        src={src}
        alt="Démarcheur"
        decoding="async"
        fetchPriority="high"
        loading="eager"
        style={{ height }}
      />
    </span>
  );
}
